import { environment } from '@environments/environment';

export const VERSION_API = "api/v1.0/operaciones/";
export const VERSION_API2 = "api/v1.1/";
export const API_URL = `${environment.API_URL}${VERSION_API}`
export const API_URL2 = `${environment.API_URL}${VERSION_API2}`;
